import { connect } from 'react-redux';
import ChargerPackagesComponent from './component';
import { getChargerPackages, setTotalCount } from './actions';

const mapStateToProps = (state) => ({
  packages: state.chargerPackages.packages,
  totalCount: state.chargerPackages.totalCount,
  isFetching: state.chargerPackages.isFetching,
});

const mapDispatchToProps = (dispatch) => ({
  getChargerPackages: (chargerUuid) => dispatch(getChargerPackages(chargerUuid)),
  setTotalCount: (totalCount) => dispatch(setTotalCount(totalCount)),
});

export const ChargerPackages = connect(mapStateToProps, mapDispatchToProps)(ChargerPackagesComponent);
